import { render } from "./constituteManagement.vue?vue&type=template&id=6eb59a0a&scoped=true"
import script from "./constituteManagement.vue?vue&type=script&lang=js"
export * from "./constituteManagement.vue?vue&type=script&lang=js"

import "./constituteManagement.vue?vue&type=style&index=0&id=6eb59a0a&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb59a0a"]])

export default __exports__